// extracted by mini-css-extract-plugin
export var bodyRow = "_f8-d";
export var cardColumns = "_f8-e";
export var ellipsesOverflow = "_f8-2";
export var flatBottomCorners = "_f8-3";
export var flatTopCorners = "_f8-4";
export var headerActionsDropdown = "_f8-f";
export var headerBottomRow = "_f8-c";
export var headerTopRow = "_f8-b";
export var orderDetailsWrapper = "_f8-0";
export var orderInfoContainer = "_f8-1";
export var productDetails = "_f8-9";
export var productImage = "_f8-5";
export var responsiveTable = "_f8-8";
export var shipmentContainer = "_f8-a";
export var tableBottomLeft = "_f8-6";
export var tableBottomRight = "_f8-7";